export const LOGO_PATH = '../../../assets/img/logo-biohealer.png';
export const AVATAR_PATH = '../../../assets/img/avatar_default.png';
